import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const UNMATCHED_PAYMENT_BANNER_TRACKING_SCHEMA = Object.freeze({
  PAYMENT_NUMBER: 0,
  BANNER_IDENTIFIER: 'match_payment',
  BANNER_TYPE: 'match_payment',
});
const RECORD = generateSchema(UNMATCHED_PAYMENT_BANNER_TRACKING_SCHEMA);
const KEYS: any = generateKeys(UNMATCHED_PAYMENT_BANNER_TRACKING_SCHEMA);

export class UnmatchedPaymentBannerTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.banner;
  }

  get properties() {
    return this.toJS();
  }
}
